<template>
  <div>
    <div class="d-flex flex-grow">
      <div class="custom-select-box">
        <div
          class="aha-selected-option"
          ref="selectedOption"
          @click="toggleDropdown"
          :style="{'font-family' : value}"
        >
          {{ valueSelect || $i18nPresenter.t("Select Font") }}
          <aha-icon
            :class="{ 'arrow-up': dropdownOpen, 'arrow-down': !dropdownOpen }"
            class="absolute ml-auto pointer-events-none top-4 right-3"
            name="arrow"
            viewBox="0 0 24 24"
            width="10"
            height="10"
          />
        </div>
        <ul
          class="dropdown-menu-custom"
          ref="dropdownMenu"
          :style="{ visibility: dropdownOpen ? 'visible' : 'hidden'}"
        >
          <li class="add-font-select " @click="openModal">
            <font-awesome-icon icon="plus" size="sm" /> {{ $i18nPresenter.t('More fonts') }} <div class="relative">
              <img
                class="cursor-pointer ml-2 mb-0.5"
                src="@/assets/images/pro.svg"
                v-if="!(isProPlan || isWhiteLabel) && isBeforeCurrentPeriodStart"
              />
              <PlanUpgradeModal
                v-if="isBeforeCurrentPeriodStart"
                :popup="'center'"
                :isShowTooltip="ctaUpgradeFont"
                :name-feature="'Font'"
                @outsideEvent="clickOutsideUpPresentationFont"
              />
              <div v-if="ctaUpgradeFont && isBeforeCurrentPeriodStart" class="upgrade-arrow upgrade-arrow_slide"></div>
            </div>
          </li>

          <div class="border-t border-base-30"></div>
          <!--          <div v-if="recentFonts.length > 0 ">-->
          <!--            <span class="dropdown-menu-label font-bold">-->
          <!--              <b> Recent Fonts</b>-->
          <!--            </span>-->
          <!--            <div>-->
          <!--              <li-->
          <!--                v-for="font in recentFonts"-->
          <!--                :key="font.family"-->
          <!--                @click="selectFont(font , true)"-->
          <!--                :style="{'font-family' : font.family}"-->
          <!--              >-->
          <!--                {{ font.family }}-->
          <!--              </li>-->
          <!--              <div class="pb-4 border-t border-base-30"></div>-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="scroll-zone">
            <li
              v-for="font in fonts"
              :key="font.family"
              @click="selectFont(font)"
              :style="{'font-family' : font.family, background : font.family === value ? 'rgba(59, 130, 246, 0.3)' : ''}"
            >
              {{ font.family }}
            </li>
          </div>
        </ul>
      </div>
    </div>
    <aha-modal
      v-if="isShowModal"
      :title="$i18nPresenter.t('Font library')"
      width="800px"
      @hide="handleModalConfirm()"
    >
      <font-manager-v2 @change="onChangeFont" :selected="fonts" />
      <template #action>
        <aha-link
          @click="handleModalConfirm()"
        >
          <span class="font-bold">{{ $i18nPresenter.t('Cancel') }} </span>
        </aha-link>
        <aha-button
          :disabled="fontChecked.length === 0"
          variant="primary"
          has-margin-left
          @click="addFontToSelectBox"
        >
          {{ $i18nPresenter.t('Done') }}
        </aha-button>
      </template>
    </aha-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import fontManagerV2 from './fontV2.vue'
import Util from '@/util'
import eventCategories from '@/constant/eventCategories'
import Constants from '@/constant'
import PlanUpgradeModal from '@/components-v2/presentation-editor/editor-header/PlanUpgrade.vue'

const { PRESENTATION_EDITOR } = eventCategories
const DEFAULT_FONTS = Object.keys(Constants.fonts).map((font) => Constants.fonts[font].label)
export default {
  components: { PlanUpgradeModal, fontManagerV2 },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      default: '',
      type: [String, Number],
    },
    required: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      ctaUpgradeFont: false,
      dropdownOpen: false,
      recentFonts: [],
      // selectedFont: '',
      fonts: DEFAULT_FONTS.map((defaultFont) => ({ family: defaultFont, category: defaultFont })),
      isShowModal: false,
      fontChecked: [],
    }
  },

  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    valueSelect() {
      const oldFont = Constants.fonts[this.value]
      if (oldFont) {
        return oldFont.label
      }
      return this.value
    },
    isWhiteLabel() {
      return this.$store.state.plan.group === 'white-label'
    },
    isProPlan() {
      return this.$store.state.plan.group == 'pro'
    },

    isBeforeCurrentPeriodStart() {
      return this.$store.state.currentUser.isBeforeCurrentPeriodStart
    },
  },
  watch: {
    fonts(val) {
      // set local storage
      localStorage.setItem('fonts-manager', JSON.stringify(val))
      // load font
      this.loadFont()
    },
    recentFonts(val) {
      localStorage.setItem('recent-fonts', JSON.stringify(val))
    },
  },
  created() {
    this.loadFontToLocal()
    this.loadRecentFonts()
  },

  mounted() {
    document.addEventListener('click', this.handleClickOutside)
    this.loadFont()
    window.emit = this.$emit
  },
  destroyed() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    clickOutsideUpPresentationFont() {
      this.ctaUpgradeFont = false
    },
    handleModalConfirm() {
      this.isShowModal = false
      this.fontChecked = []
      Util.mixpanelTracking(PRESENTATION_EDITOR, 'Design > Font library > Cancel', null, null, {
        presentationId: this.$store.state.presentation.id,
        plan: this.currentUser.plan,
      })
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.dropdownOpen = false
      }
    },
    loadRecentFonts() {
      const recentFonts = localStorage.getItem('recent-fonts')
      if (recentFonts) {
        this.recentFonts = JSON.parse(recentFonts)
      }
    },
    openModal() {
      if (!this.isProPlan && this.isBeforeCurrentPeriodStart) {
        this.ctaUpgradeFont = true
        return
      }
      this.isShowModal = true
      this.dropdownOpen = false
      Util.mixpanelTracking(PRESENTATION_EDITOR, 'Design > Font > More Font', null, null, {
        presentationId: this.$store.state.presentation.id,
        plan: this.currentUser.plan,
      })
    },
    loadFontToLocal() {
      const fonts = localStorage.getItem('fonts-manager')
      if (fonts) {
        this.fonts = JSON.parse(fonts)
      }
    },
    loadFont() {
      // eslint-disable-next-line array-callback-return
      this.fonts.map((font) => {
        // find font size exist in head
        const { head } = document
        const fontSheets = head.querySelectorAll('[data-font]')
        let isExist = false
        fontSheets.forEach((sheet) => {
          if (sheet.dataset.font == font.family) {
            isExist = true
          }
        })
        if (isExist) return
        const link = `https://fonts.googleapis.com/css?family=${font.family}`
        const el = document.createElement('link')
        el.href = link
        // set attribute font
        el.setAttribute('data-font', font.family)
        el.rel = 'stylesheet'
        document.head.appendChild(el)
      })
    },
    onChangeFont(fontChecked) {
      this.fontChecked = fontChecked.map((font) => {
        return {
          family: font.family,
          id: font.id,
        }
      })
    },
    addFontToSelectBox() {
      this.fonts = [...this.fontChecked]
      this.isShowModal = false
      Util.mixpanelTracking(PRESENTATION_EDITOR, 'Design > Font library > Added more fonts', null, null, {
        fonts: this.fonts.map((font) => font.family).join(', '),
        plan: this.currentUser.plan,
      })
      this.fontChecked = []
    },
    toggleDropdown() {
      //  check dropdown open
      // get postion ref selectedOption
      this.dropdownOpen = !this.dropdownOpen
      const { top } = this.$refs.selectedOption.getBoundingClientRect()
      // get height dropdown

      const height = this.$refs.dropdownMenu.clientHeight

      // get height window
      const heightWindow = window.innerHeight
      // check height dropdown
      if (top + height > heightWindow) {
        this.$refs.dropdownMenu.style.top = `-${height + 2}px`
      } else {
        this.$refs.dropdownMenu.style.top = '100%'
      }

      // track open click font
      Util.mixpanelTracking(
        PRESENTATION_EDITOR,
        'Design > Font > Open dropdown menu',
        this.$store.state.presentation.id,
        null,
        {
          plan: this.currentUser.plan,
        },
      )
    },

    selectFont(font, recent = false) {
      this.$emit('change', font.family)
      if (recent) {
        Util.mixpanelTracking(PRESENTATION_EDITOR, 'Design > Open font selection box > Recent Fonts', null, null, {
          font: font.family,
          plan: this.currentUser.plan,
        })
      }
      this.dropdownOpen = false
      // if (this.recentFonts.length >= DEFAULT_RECENT_COUNT) {
      //   this.recentFonts.pop()
      // }
      // if (this.recentFonts.find((recentFont) => recentFont.family === font.family)) return
      // this.recentFonts = [font, ...this.recentFonts]
    },

  },

}
</script>

<style lang="scss" scoped>
ul {
  list-style-type: none;
  padding: 0;
}

.add-font-select{

  display: flex;
  align-items: center;
  font-size: 14px;
  svg {
    margin-right: 10px;
  }
  @media (max-width: 540px) {
    display:none;
  }
}
.custom-select-box {
  position: relative;
  display: inline-block;
  width: 250px;
}

.aha-selected-option {
  padding: 10px;
  border: 1px solid #ccc;
  cursor: pointer;
  position: relative;
  background-color: #fff;
  @apply appearance-none overflow-ellipsis;
  @apply pl-2 pr-6 py-2 text-sm rounded w-full border border-secondary-20;
  @apply focus:bg-primary-20 focus:border-primary-90 focus:outline-none;
  @apply placeholder-base-70;
  &:hover{
    @apply bg-primary-20 border-primary-90;
  }
}
.aha-button-add-font{
  margin-left: 3px;
}
.arrow-icon {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  width: 10px;
  height: 10px;
  border-top: 2px solid #000;
  border-right: 2px solid #000;
  transition: transform 0.3s;
}

.arrow-up {
  transform: translateY(-50%) rotate(180deg);
}

.arrow-down {
  transform: translateY(-50%) rotate(0deg);
}

.dropdown-menu-custom {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  //max-height: 250px;
  //overflow-y: auto;
  list-style-type: none;
  padding: 0;
  margin: 0;
  background-color: #fff;
  z-index: 1;
  border: 1px solid #D3D7E1;
  box-shadow: 3px 3px 5px rgba(211, 215, 225, 0.42);
  border-radius: 4px;
}

.dropdown-menu-label {
  padding : 0px 0px 5px 10px;
  text-overflow: ellipsis;
  color: #3c4043;
  font-weight: 500;
}
.dropdown-menu-custom li {
  padding: 10px 10px 10px 20px;
  cursor: pointer;
}

.scroll-zone{
  max-height: 150px;
  overflow-y: auto;
}
.dropdown-menu-custom li:hover {
  background-color: #F0F4FA;
}
.upgrade-arrow {
  width: 0;
  height: 0;
  border-width: 0 8px 8px 8px;
  border-color: transparent transparent rgba(40, 46, 62, var(--tw-bg-opacity)) transparent;
  border-style: solid;
  position: absolute;
  z-index: 1;
  top: 1.6rem;

  &.upgrade-arrow_slide {
    left: calc(50% - 4px);
  }
}

</style>
